/**
 * FDV — <fdv-ritual-reveal>
 *
 * Realza un <details> nativo del PDP ("Desbloquea el ritual de esta vela"):
 * dispara la animación de revelado y emite el evento de analítica la primera
 * vez que se abre. Sin JS el <details> sigue funcionando (progressive
 * enhancement) — solo se pierde la animación y el evento.
 *
 * Contenido = metafield `custom.ritual_reveal` (rich text). Ver
 * blocks/fdv-ritual-reveal.liquid y docs/migration/16-modales-gamificados.md
 * (Etapa 3 · Producto).
 */
class FdvRitualReveal extends HTMLElement {
  connectedCallback() {
    this.details = this.querySelector('details');
    if (!this.details) return;

    this._revealed = false;
    this._onToggle = this._onToggle.bind(this);
    this.details.addEventListener('toggle', this._onToggle);
  }

  disconnectedCallback() {
    this.details?.removeEventListener('toggle', this._onToggle);
  }

  _onToggle() {
    if (!this.details.open) return;

    // Reinicia la animación cada apertura (solo si no la pausa el usuario).
    const body = this.details.querySelector('.fdv-ritual__body');
    if (body && !window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
      body.classList.remove('fdv-ritual__body--in');
      // Fuerza reflow para poder re-disparar la animación CSS.
      void body.offsetWidth;
      body.classList.add('fdv-ritual__body--in');
    }

    if (this._revealed) return;
    this._revealed = true;

    try {
      window.FDV?.track?.('fdv_ritual_revealed', {
        product_id: this.dataset.productId || null,
        product_handle: this.dataset.productHandle || null,
      });
    } catch (e) {
      /* el tracking nunca debe romper la UI */
    }
  }
}

if (!customElements.get('fdv-ritual-reveal')) {
  customElements.define('fdv-ritual-reveal', FdvRitualReveal);
}
